module.exports = __webpack_public_path__ + "static/img/b4.46b5350.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b4.jpg
// module id = 249
// module chunks = 0 1 2 3 4 5 6 7 8 9